import { useContext, useEffect } from 'react';
import { AppContext } from '../../AppModulesWrapper';
import { useDeviceWidth } from '../../ServicePickerWidget/hooks';
import { useDispatch } from 'react-redux';
import { updateAdaptiveSettings } from '../../ServicePickerWidget/actions/layout';
import { getAdaptiveSettings } from '../../ServicePickerWidget/services/getAdaptiveSettings';

export const useAdaptiveSettings = () => {
  const {
    custom: { userAgent },
  } = useContext(AppContext);

  const deviceWidth = useDeviceWidth();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateAdaptiveSettings(getAdaptiveSettings({ userAgent, deviceWidth })));
  }, [deviceWidth, dispatch, userAgent]);
};
